import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import { Button, Icon, Modal } from "semantic-ui-react";

import { copyToClipboard } from "utils/common";

type AttachmentsListProps = {
  attachments: string[];
  showAttachments: boolean;
  hasAttachmentsError: boolean;
  close: () => void;
};

export const AttachmentsList = ({ showAttachments, close, attachments, hasAttachmentsError }: AttachmentsListProps) => {
  const { t } = useTranslation();

  if (hasAttachmentsError) {
    toast.error(t("v8_something_went_wrong", "Something went wrong"), { containerId: "logs-attachments-modal-toast" });
    return;
  }

  const handleCopyAllAttachmentUrls = async () => {
    await copyToClipboard(attachments.join("\n"));
    toast.success(t("v8_all_attachments_copied", "All attachments copied"), { containerId: "logs-attachments-modal-toast", autoClose: 5000 });
  };

  return (
    <Modal open={showAttachments} onClose={close} closeOnDimmerClick className="Logs">
      <Modal.Header className="logs-title">
        <p>{t("v8_all_pictures", "All pictures")}</p>
        <Button className="-appointment-status" size="small" onClick={close}>
          <Icon className="xmark grey" size="big" />
        </Button>
      </Modal.Header>
      <Modal.Content scrolling>
        <div className="attachments-list">
          {attachments.map((a, idx) => (
            <a href={a} target="_blank" rel="noreferrer" key={idx}>
              {a}
            </a>
          ))}
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button active className="-appointment-status icon" size="small" onClick={handleCopyAllAttachmentUrls}>
          <Icon name="copy" />
          {t("v8_copy_all_links", "Copy all links")}
        </Button>
      </Modal.Actions>
      <ToastContainer containerId="logs-attachments-modal-toast" position="top-right" autoClose={1500} closeOnClick draggable theme="light" />
    </Modal>
  );
};
